import { useRouter } from "next/router"
import Image from "components/Image"
import CallToAction from "components/CallToAction"
import { BLOG_ARTICLES_PER_PAGE } from "utilities/blogHelpers"
import richText from "utilities/richText"
import Pagination from "../Pagination"
import PatternedDiv from "components/PatternedDiv"
import { getExcerpt } from "utilities/getExcerpt"

const ArticleItem = ({ article }) => {
  const Thumbnail = () => {
    return (
      <div className="w-full relative h-48">
        <Image
          placeholder={article?.content?.featured_image?.blurDataURL ? "blur" : "empty"}
          blurDataURL={article?.content?.featured_image?.blurDataURL}
          src={article?.content?.featured_image?.filename || "/assets/blog-item-placeholder.svg"}
          alt={article?.content?.featured_image?.alt || "Decorative blog image"}
          fill
          sizes="(min-width: 1240px) 392px, (min-width: 1024px) 360px, (min-width: 768px) 448px, (min-width: 640px) 671px, (min-width: 520px) 543px, 423px"
          className="rounded-t-4xl object-cover"
        />
      </div>
    )
  }
  return (
    <div className="relative z-10 bg-white rounded-4xl shadow-lg flex flex-col ">
      <Thumbnail />
      <div className="p-8 pb-20 relative">
        <h3 className="text-m2 mb-2 text-black/80 uppercase font-secondary">{article?.content?.title}</h3>
        <div className="max-h-64 text-black/80 overflow-hidden font-light">
          {getExcerpt(article?.content?.excerpt, 350)}
        </div>
        <div className="absolute bottom-8">
          <CallToAction href={`/blog/${article?.slug}`} style="secondary-light">
            Read More
          </CallToAction>
        </div>
      </div>
    </div>
  )
}

export default function BlogArticlesSection({ blogArticles, total, number }) {
  const router = useRouter()
  return (
    <section className="bg-warm-white">
      <PatternedDiv>
        <div id="blog-section">
          {blogArticles?.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 relative">
              {blogArticles?.map((article, idx) => (
                <ArticleItem article={article} key={idx} />
              ))}
            </div>
          ) : (
            <div className="px-10 lg:pl-6 lg:pr-12 pb-12 lg:pb-0">
              <p>Sorry, we did not find any articles in this category. Please try another category or visit the:</p>
              <CallToAction href="/blog" style="secondary">
                main blog page
              </CallToAction>
            </div>
          )}
        </div>
        <Pagination
          scrollAnchor="blog-section"
          pageCount={Math.ceil(total / BLOG_ARTICLES_PER_PAGE)}
          currentPage={number}
          setCurrentPage={(number) =>
            router.push(`${router.pathname.replace("[number]", number)}`, null, {
              scroll: false,
            })
          }
        />
      </PatternedDiv>
    </section>
  )
}
